/**
 * External dependencies
 */
import React, { Component } from 'react';
import { injectStripe, CardElement } from 'react-stripe-elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import classNames from 'classnames';

/**
 * Internal depdendencies
 */
import Loader from '../../loader';
import { isLoggedIn, getCurrentUser } from '../../../lib/auth';

class AddCardForm extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fontSize: '15px',
            lineHeight: 1.8,
            message: '',
            status: '',
            loading: false,
        };
    }

    componentDidMount() {
        this.setOptions();
        window.addEventListener( 'resize', this.setOptions );
    }

    componentWillUnmount() {
        window.removeEventListener( 'resize', this.setOptions );
    }

    handleFormFieldChange = ( event ) => {
        this.setState( { [ event.target.name ]: event.target.value } );
    };

    handleFormSubmit = ( event ) => {
        event.preventDefault();

        const {
            stripe,
            onSuccess,
        } = this.props;

        const user = getCurrentUser();

        const {
            stripeCustomerId,
        } = user;

        if ( stripe && stripeCustomerId ) {
            this.setState( {
                loading: true,
            } );

            stripe.createToken().then( ( result ) => {
                if ( result.error ) {
                    this.setState( {
                        message: result.error.message,
                        loading: false,
                    } );
                } else {
                    if ( result.token ) {
                        axios.post( `${process.env.GATSBY_BACK_END_URL}/change-card`, {
                            stripeCustomerId,
                            token: result.token,
                        } ).then( ( response ) => {
                            if ( response && response.data ) {
                                const {
                                    status,
                                    message,
                                    clientSecret,
                                } = response.data;

                                this.setState( {
                                    status,
                                    message,
                                    loading: status === 'requires_action',
                                } );

                                if ( status !== 'requires_action' ) {
                                    setTimeout( () => {
                                        if ( onSuccess ) {
                                            onSuccess();
                                        }
                                    }, 3000 );
                                }

                                if ( status === 'requires_action' && clientSecret ) {
                                    stripe.handleCardPayment( clientSecret ).then( ( authResult ) => {
                                        if ( authResult.error ) {
                                            this.setState( {
                                                status: 'error',
                                                message: authResult.error.message,
                                                loading: false,
                                            } );
                                        } else {
                                            this.setState( {
                                                status: 'success',
                                                message: 'You\'ve successfully changed payment method.',
                                                loading: false,
                                            } );
                                            setTimeout( () => {
                                                if ( onSuccess ) {
                                                    onSuccess();
                                                }
                                            }, 3000 );

                                        }
                                    } );
                                }
                            }
                        } ).catch( ( error ) => {
                            console.log( error );
                        } );
                    }
                }
            } );
        } else {
            console.log( 'Stripe.js hasn\'t loaded yet.' );
        }
    };

    setOptions = () => {
        if ( window.outerWidth > 1023 ) {
            this.setState( {
                fontSize: '18px',
                lineHeight: 1.2,
            } );
        } else if ( window.outerWidth > 767 ) {
            this.setState( {
                fontSize: '16px',
                lineHeight: 1.5,
            } );
        } else {
            this.setState( {
                fontSize: '15px',
                lineHeight: 1.7,
            } );
        }
    };

    render() {
        const {
            fontSize,
            lineHeight,
            message,
            status,
            loading,
        } = this.state;

        const stripeElementOptions = {
            style: {
                base: {
                    fontSize,
                    color: '#333333',
                    fontFamily: 'Open Sans, sans-serif',
                    '::placeholder': {
                        color: '#666666',
                    },
                    lineHeight,
                },
                invalid: {
                    color: '#666666',
                },
            },
        };

        const formButtonAsideTextClasses = classNames( 'form-button-aside-text', status ? `is-${status}` : '' );

        return (
            <div>
                { isLoggedIn() ? (
                    <div className="form" id="add-card-form">
                        <form onSubmit={ this.handleFormSubmit }>
                            <fieldset>
                                <div className="input-wrap">
                                    <label htmlFor="card-details-add-card">
                                        New payment method
                                        <CardElement
                                            id="card-details-add-card"
                                            name="card-details-add-card"
                                            { ...stripeElementOptions }
                                        />
                                    </label>
                                </div>
                                <div className="input-wrap d-md-flex align-items-md-center">
                                    <button className="button is-green has-icon flex-md-shrink-0" type="submit">
                                        Change payment method
                                        <FontAwesomeIcon icon="arrow-right" />
                                    </button>
                                    <span className={ formButtonAsideTextClasses }>
                                    { ( loading && <Loader /> ) || message }
                                </span>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                ) : (
                    <p>You need to be logged in to use this form.</p>
                ) }
            </div>
        );
    }
}

export default injectStripe( AddCardForm );
